import { ref } from '@vue/composition-api'
import { GardenReportService } from '@/app/reports/garden/services/garden.report.service'

export default function gardenReportLogic() {

  const plansFilterRequest = ref({
   
    contarcts:[],
    plans: [],
  })

  const report_data = ref(null)

  const from = ref(0)
  const to = ref(0)
  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)


  const getReport = () => {

    errors.value = {}
    loading.value = true
    
    GardenReportService.getReport(request.value)
      .then(res => {
        report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  loading.value = false)
  }



  const getReportForPdf = () => {
    return new Promise((r, j) => {
      GardenReportService.getReport(Object.assign(request.value, {
        page:1, length: 50000
      })).then(res => r(res.data.data))
    })
  }


  return {
    getReport,getReportForPdf,
    report_data,
    total, from, to,
    plansFilterRequest,
    loading,
    errors

  }
}
